import * as React from 'react'
import { useGetPublishedCampaignCardsQuery } from '../types/issuer-graphql'
import { client } from '../lib/issuer-client/client'
import { CardTypeEnum } from '/fiweb/components/CampaignCard/types'
import { normalizeNewApiCampaignCards } from '../utils/campaignCard'

export const useCampaignsHomeSubQuery = () => {
  const {
    data,
    error: newError,
    loading,
    previousData,
  } = useGetPublishedCampaignCardsQuery({ client, skip: !client, pollInterval: 30000 })

  const cards = React.useMemo(
    () => normalizeNewApiCampaignCards((data ?? previousData)?.getPublishedCampaignCards || []),
    [data, previousData],
  )

  const ongoing = cards.filter((card) => card.state === CardTypeEnum.ONGOING)
  const upcoming = cards.filter((card) => card.state === CardTypeEnum.UPCOMING)
  const comingSoon = cards.filter((card) => card.state === CardTypeEnum.COMING_SOON)

  return {
    ongoing,
    upcoming,
    comingSoon,
    error: newError,
    loading,
  }
}
